import { useEffect, useRef, useState } from 'react';
import {
  computeMobilePanelHeight,
  snapMobilePanelHeight,
  applyMobilePanelChromeStyles
} from '../utils/dashboard/sidebarDragHelpers';

/**
 * 指挥页移动端底部面板拖拽状态
 */
export default function useMobilePanelDrag({ isMobile }) {
  const [mobileContainerHeight, setMobileContainerHeight] = useState(0.1);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartY, setDragStartY] = useState(0);
  const [dragStartHeight, setDragStartHeight] = useState(0);
  const mobileContainerRef = useRef(null);

  const handleMobileDragStart = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setDragStartY(e.touches ? e.touches[0].clientY : e.clientY);
    setDragStartHeight(mobileContainerHeight);
    document.body.style.userSelect = 'none';
  };

  const handleMobileDragMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const currentY = e.touches ? e.touches[0].clientY : e.clientY;
    setMobileContainerHeight(computeMobilePanelHeight({
      startY: dragStartY,
      currentY,
      startHeight: dragStartHeight,
      screenHeight: window.innerHeight
    }));
  };

  const handleMobileDragEnd = () => {
    setIsDragging(false);
    document.body.style.userSelect = '';
    setMobileContainerHeight((prev) => snapMobilePanelHeight(prev));
  };

  const handleExpandClick = () => {
    setMobileContainerHeight(0.4);
    setTimeout(() => {
      applyMobilePanelChromeStyles(mobileContainerRef.current, 0.4);
    }, 50);
  };

  const handleCollapseClick = () => {
    setMobileContainerHeight(0.1);
    setTimeout(() => {
      applyMobilePanelChromeStyles(mobileContainerRef.current, 0.1);
    }, 50);
  };

  useEffect(() => {
    if (!isMobile || !isDragging) return undefined;

    const handleTouchMove = (e) => handleMobileDragMove(e);
    const handleMouseMove = (e) => handleMobileDragMove(e);
    const handleTouchEnd = () => handleMobileDragEnd();
    const handleMouseUp = () => handleMobileDragEnd();

    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('touchend', handleTouchEnd);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('touchend', handleTouchEnd);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, isMobile]); // 与原 Dashboard 一致：仅在拖拽态切换时绑定全局监听

  useEffect(() => {
    applyMobilePanelChromeStyles(mobileContainerRef.current, mobileContainerHeight);
  }, [mobileContainerHeight]);

  return {
    mobileContainerHeight,
    setMobileContainerHeight,
    isDragging,
    mobileContainerRef,
    handleMobileDragStart,
    handleExpandClick,
    handleCollapseClick
  };
}
